import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng/ui_base';
import Ad, { handleAd } from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Tabs from './tabs';
import TabPane from './tabPane';
import ContentList from './contentList';

class Info extends React.Component {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        insertArr: [],
        replaceArr: [],
        adFn: null,
        acticeIndex: 0,
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            this.setState({
                insertArr,
                replaceArr,
                adFn,
                acticeIndex: this.acticeIndex,
            });
        }

        return;
    };

    adInit = async (index, len) => {
        this.acticeIndex = index;

        if (!(this.event.events && this.event.events.init)) {
            try {
                const { infoAd } = this.props.content;
                const callback = await handleAd(infoAd);

                callback(infoAd.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }
        }

        try {
            this.event.trigger('init', { index, len });
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { insertArr, replaceArr, adFn, acticeIndex } = this.state;
        const {
            content: { infoTitle, hardAd },
        } = this.props;

        return (
            <div className={styles.info}>
                <Tabs>
                    {infoTitle.map((item, index) => (
                        <TabPane key={index} tab={item.title}>
                            <ContentList
                                index={index}
                                acticeIndex={acticeIndex}
                                dataKey={item.key}
                                event={this.event}
                                adInit={this.adInit}
                                insertArr={insertArr}
                                replaceArr={replaceArr}
                                adFn={adFn}
                            />
                        </TabPane>
                    ))}
                </Tabs>
                <NoSSR onSSR={<div className={styles.hardAd} />}>
                    <Ad content={hardAd} styleName={styles.hardAd} />
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Info);
